import React from 'react';
import styled from '@emotion/styled';
import { CircularProgress, Typography } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const Container = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  marginTop: theme.spacing(4),
}));

export const Title = styled(Typography)(({ theme }: { theme: ICustomTheme }) => ({
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.colors.grey.dark,
}));

export const Message = styled(Typography)(({ theme }: { theme: ICustomTheme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(2),
  color: theme.colors.grey.dark,
}));

export const ButtonContainer = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  '& button': {
    width: 330,
    '&:hover svg': {
      color: theme.colors.paletteFromBO.main,
    },
  },
}));

export const Spinner = styled(CircularProgress)(
  ({ theme }: { theme: ICustomTheme }) => ({
    marginRight: theme.spacing(1),
    color: theme.colors.white,
  }),
);

interface AuthInfoPageProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Scaffold partagé par les pages d'information du parcours auth
 * (lien expiré, compte déjà activé…) : un titre centré suivi d'un contenu libre.
 */
export default function AuthInfoPage({ title, children }: AuthInfoPageProps) {
  return (
    <Container>
      <Title>{title}</Title>
      {children}
    </Container>
  );
}
